<template>
  <div class="route-map-card">
    <h4>Google Maps vanuit {{ cityName }}</h4>
    <p class="route-map-summary">
      Vanaf {{ cityName }} is Tandzorg Gestel goed bereikbaar.
      <span v-if="driveTime"> Met de auto ongeveer {{ driveTime }}.</span>
      <span v-if="transitTime"> Met het openbaar vervoer ongeveer {{ transitTime }}.</span>
    </p>

    <div class="route-map-frame">
      <iframe
        :src="embedUrl"
        width="100%"
        height="260"
        style="border:0;"
        loading="lazy"
        allowfullscreen=""
        referrerpolicy="no-referrer-when-downgrade"
        :title="`Route van ${cityName} naar Tandzorg Gestel`"
      ></iframe>
    </div>

    <a :href="routeUrl" target="_blank" rel="noopener noreferrer" class="route-map-link">
      Open route in Google Maps
    </a>
  </div>
</template>

<script>
export default {
  name: 'LocalRouteMap',
  props: {
    cityName: {
      type: String,
      required: true
    },
    originQuery: {
      type: String,
      required: true
    },
    driveTime: {
      type: String,
      default: ''
    },
    transitTime: {
      type: String,
      default: ''
    }
  },
  computed: {
    destinationQuery() {
      return 'Schijndelseweg 13A, 5271 BK Sint-Michielsgestel'
    },
    embedUrl() {
      const query = encodeURIComponent(`route van ${this.originQuery} naar ${this.destinationQuery}`)
      return `https://maps.google.com/maps?hl=nl&q=${query}&z=11&output=embed`
    },
    routeUrl() {
      const origin = encodeURIComponent(this.originQuery)
      const destination = encodeURIComponent(this.destinationQuery)
      return `https://www.google.com/maps/dir/?api=1&origin=${origin}&destination=${destination}&travelmode=driving`
    }
  }
}
</script>

<style scoped>
.route-map-card {
  background: #ffffff;
  padding: 2rem;
  border-radius: 10px;
  box-shadow: var(--box-shadow);
  margin-top: 2rem;
}

.route-map-card h4 {
  color: var(--blue);
  font-size: 1.6rem;
  margin: 0 0 1rem 0;
}

.route-map-summary {
  margin-bottom: 1.25rem;
  color: var(--light-color);
  font-size: 1.4rem;
  line-height: 1.6;
}

.route-map-frame {
  overflow: hidden;
  border-radius: 10px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  background: #f8f9fa;
}

.route-map-link {
  display: inline-block;
  margin-top: 1.2rem;
  color: var(--blue);
  font-size: 1.4rem;
  font-weight: 600;
  text-decoration: none;
}

.route-map-link:hover {
  text-decoration: underline;
}

@media (max-width: 768px) {
  .route-map-card {
    padding: 1.6rem;
  }
}
</style>